import React from "react";
import "./TeamSlider.css";
export const teamMembers = [
  {
    "id": 1,
    "name": "Shiv Bagherwal",
    "role": "CEO/COO/Co-Founder",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/shiv1.jpg",
  },
  {
    "id": 2,
    "name": "Mayank Moolchandani",
    "role": "CTO & Co-Founder",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/mayankProfile1.webp",
  },
  {
    "id": 3,
    "name": "Tim Ball",
    "role": "VP, Customer Strategy and Growth",
    "image": "/assets/team/tim-ball.jpg",
  },
  {
    "id": 4,
    "name": "Rishi Sharma",
    "role": "Head of Agentic Experiences",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/rishi1.jpg",
  },
  {
    "id": 5,
    "name": "Himanshu Vaswani",
    "role": "Global Head of Delivery",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/himanshu1.webp",
  },
  {
    "id": 6,
    "name": "Saurav Mathuriya",
    "role": "Lead Technical Architect",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/saurabh1.webp",
  },
  {
    "id": 7,
    "name": "Gaurav Rawal",
    "role": "Principal FLE",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/gaurav1.webp",
  },
  {
    "id": 8,
    "name": "Deepak Dey",
    "role": "Integration Lead",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/deepak1.webp",
  },
  {
    "id": 9,
    "name": "Rahul Jangid",
    "role": "AI Solutions Architect",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/rahul1.webp",
  },
  {
    "id": 10,
    "name": "Abhijeet Singh Rawat",
    "role": "AI Workflow Engineer",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/abhijeet1.webp",
  },
  {
    "id": 11,
    "name": "Pranay Saxena",
    "role": "Senior FLE",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/pranay1.webp",
  },
  {
    "id": 12,
    "name": "Saurabh Kumar Rai",
    "role": "Senior FLE",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/sourabh1.webp",
  },
  {
    "id": 13,
    "name": "Dhanna Ram",
    "role": "Associate Lead",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/Dhanna1.webp",
  },
  {
    "id": 14,
    "name": "Shreya Shukla",
    "role": "Associate Lead",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/shreya1.webp",
  },
  {
    "id": 15,
    "name": "Ayush Dubey",
    "role": "Marketing Director",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/ayush1.webp",
  },
  {
    "id": 16,
    "name": "Anjali Kalwani",
    "role": "HR Executive",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/anjali1.webp",
  },
  {
    "id": 17,
    "name": "Muskan Sharma",
    "role": "Senior Software Engineer",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/muskan1.webp",
  },
  {
    "id": 18,
    "name": "Priyanka Kumari",
    "role": "Senior Software Engineer",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/priyanka1.webp",
  },
  {
    "id": 19,
    "name": "Yuvraj Singh Gour",
    "role": "Senior Software Engineer",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/yuvraj1.webp",
  },
  {
    "id": 20,
    "name": "Raja Kumar",
    "role": "Senior Software Engineer",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/raja1.webp",
  },
  {
    "id": 21,
    "name": "Bajrang Mahawar",
    "role": "Senior Software Engineer",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/bajrang1.webp",
  },
  {
    "id": 22,
    "name": "Ashish Jangid",
    "role": "Operations Executive",
    "image": "https://d2lyw5vkb9es5b.cloudfront.net/ashish1.webp",
  }
]

const publicTeamMemberExclusions = new Set([
  "Rahul Jangid",
  "Dhanna Ram",
  "Shreya Shukla",
  "Yuvraj Singh Gour",
  "Bajrang Mahawar",
]);

export const publicTeamMembers = teamMembers.filter(
  (member) => !publicTeamMemberExclusions.has(member.name)
);

const getInitials = (name) => name
  .split(" ")
  .filter(Boolean)
  .slice(0, 2)
  .map((part) => part[0])
  .join("")
  .toUpperCase();

const getMemberClassName = (name) => name
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/(^-|-$)/g, "");

const TeamSlider = () => {



  return (
    <section className="vc-section vc-team" id="company-team" tabIndex={-1} aria-labelledby="vc-team-title" data-voices-theme="dark">
      <div className="vc-section-topline"><p className="vc-label">Meet the team</p><span>People behind the possibility.</span></div>
      <div className="vc-team-intro">
        <h2 className="vc-section-title" id="vc-team-title" data-company-reveal="visible">Our talented team<br /><em>of professionals.</em></h2>
        <p>Engineers, architects, and delivery teams. Together, we connect the big picture to the details that make it work.</p>
      </div>
        <div className="vc-team-grid">
          {publicTeamMembers.map((member, i) => (
            <article key={member.id} className={`vc-team-card vc-team-card--${getMemberClassName(member.name)}`} data-company-reveal="visible" style={{ '--vc-reveal-delay': `${i % 4 * 55}ms` }}>
              <div className="vc-team-photo">
                {member.image ? (
                  <img src={member.image} alt={member.name} loading="lazy" decoding="async" width="320" height="400" />
                ) : (
                  <div className="vc-team-fallback" aria-label={member.name}>
                    {getInitials(member.name)}
                  </div>
                )}
              </div>
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </article>
          ))}
        </div>
      <p className="vc-team-note">Team profiles as provided by Antrazal.</p>
    </section>
  );
};

export default TeamSlider;
